'use client';
import React from 'react';
import { ImageObj } from '@custom-types/ImageObj.types';
import { getLeadGenerationOptions } from '@services/properties/getLeadGenerationOptions';
import { datadogLogs } from '@datadog/browser-logs';
import { CustomRegistration } from '@components/CustomRegistration';
import ParallaxBlock from '@components/ParallaxBlock';
import CommonContainer from '@components/CommonContainer';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
type Props = {
  images: ImageObj[];
  t: any;
};
const leadFormId = 'islands-lead-form';

export const scrollToLeadForm = () => {
  const el = document.getElementById(leadFormId);
  if (!el) {
    datadogLogs.logger.error('Lead form element not found');
    return;
  }
  el.scrollIntoView({ block: 'start', behavior: 'smooth' });
};
export const FAHIDISLAND_ID = 'fahid-island-registration';
export const scrollToLSQTwichenhamRegisterForm = () => {
  const el = document.getElementById(FAHIDISLAND_ID);
  if (el) {
    el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
};
export default function HouseRegistration(props: any) {
  const { t } = props;
  const [countryCode, setCountryCode] = React.useState<{}[]>([]);
  const [nationalities, setNationalities] = React.useState<{}[]>([]);
  const leadMetaRequest = React.useMemo(() => getLeadGenerationOptions(), []);
  const setLeadMetaData = async () => {
    const { countryCode, nationalities } = await leadMetaRequest.getResponse();
    setNationalities(nationalities);
    setCountryCode(countryCode);
  };
  React.useEffect(() => {
    setLeadMetaData();
    return () => leadMetaRequest.abort();
  }, []);

  return (
    <Stack component="section" className={cn.beachHouseRegistration}>
      <Box
        className={cn.beachRegistrationInner}
        sx={{
          backgroundImage: `url(${props.beachRegistrationBackground.url})`,
        }}
      >
        <CommonContainer maxWidth={{ xs: '100%', md: '1320px' }} flexGrow={1}>
          <Box className={cn.beachRegistrationBody}>
            <Box className={cn.beachRegistrationBlock}>
              <Box className={cn.beachRegistrationContent}>
                <Box className={cn.beachRegistrationContent__heading}>
                  <ParallaxText
                    variant="h2"
                    animationType="slideInLeft"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(t['beachHouseRegistrationHeading'])}
                  </ParallaxText>
                </Box>
                <Box className={cn.beachRegistrationContent__description}>
                  <ParallaxText
                    variant="p"
                    animationType="slideInLeft"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(t['beachHouseRegistrationContent'])}
                  </ParallaxText>
                </Box>
              </Box>
              <Box className={cn.beachRegistrationForm} id={FAHIDISLAND_ID}>
                <CustomRegistration
                  t={t}
                  successPopUpLink={props.successPopUpLink}
                  privacyPolicyLink={props.privacyPolicyLink}
                  termsAndConditionsLink={props.termsAndConditionsLink}
                  countryCodes={countryCode}
                  nationalities={nationalities}
                  formId={props.formId}
                  formType={props.formType}
                  projectName={props.projectName}
                  variant="modal"
                  className={cn.beachHouseRegistrationWrapper}
                  listClassName={cn.beachHouseRegistrationList}
                  blockClassName={cn.beachHouseRegistrationBlocks}
                  inputClassName={cn.beachHouseRegistrationInputs}
                  elementClassName={cn.beachHouseRegistrationElement}
                  submitBlockClassName={cn.beachHouseSubmitBlock}
                  submitClassName={cn.beachHouseRegistrationButton}
                  authClassName={cn.beachHouseRegistrationAuth}
                  marksClassName={cn.beachHouseCheckMarck}
                  contentClassName={cn.beachHouseSuccessContent}
                  buttonClassName={cn.beachHouseSuccessButton}
                  validationClassName={cn.beachHouseValidation}
                />
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
